// extracted by mini-css-extract-plugin
export default {"cardsContainer":"styles-module__cardsContainer--_oHSU"};